<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2>
          <span>{{ 'plugins.installationanilox.header' | translate }}</span>
        </h2>
      </div>
      <div
        class="ir-content--modal th-content th-content-customer"
        formArrayName="anilox"
        *ngFor="let item of formData.controls; let i = index"
      >
        <div>
          <table class="ir-modal-table">
            <tr>
              <td></td>
              <td class="th-plugin-line--remove th-plugin-line--remove-customer" colspan="2" align="right">
                <i class="material-icons" (click)="openAniloxDeleteConfirm(i)">remove_circle</i>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'plugins.installationanilox.anilox-number' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" style="width: 50%">
                <div class="ir-form-group" [formGroupName]="i">
                  <input type="text" formControlName="aniloxNumber" class="ir-form-set" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'plugins.installationanilox.supplier' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" style="width: 50%">
                <div class="ir-form-group" [formGroupName]="i">
                  <input type="text" formControlName="supplier" class="ir-form-set" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'plugins.installationanilox.volume' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" style="width: 50%">
                <div class="ir-form-group" [formGroupName]="i">
                  <input type="text" formControlName="volume" class="ir-form-set" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'plugins.installationanilox.angle' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" style="width: 50%">
                <div class="ir-form-group" [formGroupName]="i">
                  <input type="number" formControlName="angle" class="ir-form-set" (keyup)="checkIfPositive($event)" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'plugins.installationanilox.screen' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" style="width: 50%">
                <div class="ir-form-group" [formGroupName]="i">
                  <input type="number" formControlName="screen" class="ir-form-set" (keyup)="checkIfPositive($event)" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span>{{ 'plugins.installationanilox.delivered-prior' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" style="width: 50%">
                <div class="ir-form-group" [formGroupName]="i">
                  <select name="deliveredPrior" class="ir-form-set" formControlName="deliveredPrior">
                    <option [value]="null"></option>
                    <option [value]="true">{{ 'plugins.response.boolean.true' | translate }}</option>
                    <option [value]="false">{{ 'plugins.response.boolean.false' | translate }}</option>
                  </select>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="ir-content--modal th-content th-content-plus">
        <table class="ir-modal-table">
          <tr class="th-plugin-line--add th-plugin-line--add-customer">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #aniloxDeleteConfirm
  (confirmOutput)="remove($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete this <strong>record</strong>?'"
  [danger]="true"
></confirm>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
